import store from "@/stores";
import moment from "moment";
import { app } from "@/main.js";

export default (to, from, next) => {
	// Allow AccessDenied and validation views to proceed immediately without authentication checks
	if (to.name === "AccessDenied" || to.path === "/access-denied") {
		return next();
	}
	if (to.name === "validation" || to.path === "/validation") {
		return next();
	}

	let serverHost = app.config.globalProperties.$config.getServerHost().toString();

	let currentTime = new Date().toISOString();
	let tokenExpiry = store.state.auth.tokenExpiry;

	if (serverHost.includes("localhost") || serverHost.includes("127.0.0.1")) {
		currentTime = new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60 * 1000).toISOString();
		if (store.state.auth.tokenExpiry) {
			tokenExpiry = new Date(store.state.auth.tokenExpiry).toISOString();
		}
	}

	// check if token is expired
	if (store.state.auth.tokenExpiry && moment(currentTime).isSameOrAfter(tokenExpiry)) {
		store.commit("auth/setIsTokenExpired");
	}

	// check if user has been idle for too long
	if (store.state.auth.isAuthenticated && store.state.auth.lastActive) {
		const timeoutMinutes = process.env.VUE_APP_SESSION_TIMEOUT_MINUTES ? parseInt(process.env.VUE_APP_SESSION_TIMEOUT_MINUTES) : 45;
		const idleTimeoutMs = timeoutMinutes * 60 * 1000;
		const now = new Date().getTime();
		if (now - store.state.auth.lastActive > idleTimeoutMs) {
			store.commit("auth/setIsTokenExpired");
		}
	}

	if (to.meta.requiresAuth && (!store.state.auth.isAuthenticated || store.state.auth.isTokenExpired)) {
		if (to.path && to.path !== "/") {
			store.commit("auth/setRedirectLink", to.path);
		}

		store.dispatch("auth/redirectToLogin");
		return next();
	}

	// Guard against unentitled personas (only for valid, non-expired sessions)
	if (store.state.auth.isAuthenticated && !store.state.auth.isTokenExpired) {
		if (store.state.auth.jwtPayload) {
			store.commit("auth/setJwtPayload", store.state.auth.jwtPayload);
		}
		const isSuperAdmin = store.getters["auth/isSuperAdmin"] !== undefined
			? store.getters["auth/isSuperAdmin"]
			: store.state.auth.isSuperAdmin;
		const isAdmin = store.getters["auth/isAdmin"] !== undefined
			? store.getters["auth/isAdmin"]
			: store.state.auth.isAdmin;
		const isConsultant = store.getters["auth/isConsultant"] !== undefined
			? store.getters["auth/isConsultant"]
			: store.state.auth.isConsultant;
		const isGeneralUser = store.getters["auth/isGeneralUser"] !== undefined
			? store.getters["auth/isGeneralUser"]
			: store.state.auth.isGeneralUser;
		const isOrgAdmin = store.getters["auth/isOrgAdmin"] !== undefined
			? store.getters["auth/isOrgAdmin"]
			: store.state.auth.isOrgAdmin;
		const isSparkProductEnabled = store.getters["auth/isSparkProductEnabled"] !== undefined
			? store.getters["auth/isSparkProductEnabled"]
			: store.state.auth.isSparkProductEnabled;

		// Scenario B: Organisation Admin for Spark-disabled organisation
		if (isOrgAdmin && !isSparkProductEnabled && !isSuperAdmin && !isAdmin && !isConsultant) {
			store.dispatch("auth/redirectToAuthSettings");
			return next(false);
		}

		// Scenario A: General user or no valid Spark roles
		if (isGeneralUser || (!isSuperAdmin && !isAdmin && !isConsultant)) {
			store.dispatch("auth/redirectToAuthSettings");
			return next(false);
		}

		// Proactive refresh for active users when token is expiring soon
		if (store.state.auth.lastActive) {
			const now = new Date().getTime();
			const tokenExpiryVal = store.state.auth.tokenExpiry;
			if (tokenExpiryVal) {
				const expiryMs = new Date(tokenExpiryVal).getTime();
				const timeToExpiryMs = expiryMs - now;
				// If token is expiring in less than 30 minutes (and not already completely expired)
				if (timeToExpiryMs > 0 && timeToExpiryMs < 30 * 60 * 1000) {
					store.dispatch("auth/refreshToken");
				}
			}
		}
	}

	if (to.meta.requiresSuperAdmin && (!store.state.auth.isSuperAdmin || store.state.auth.isAdmin || store.state.auth.isConsultant)) {
		return next("/dashboard");
	}

	return next();
}
